import { render } from "./ListadoVentas.vue?vue&type=template&id=29042278&scoped=true"
import script from "./ListadoVentas.vue?vue&type=script&lang=js"
export * from "./ListadoVentas.vue?vue&type=script&lang=js"

import "./ListadoVentas.vue?vue&type=style&index=0&id=29042278&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29042278"]])

export default __exports__